import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
import useLicenseCheck from "license/useLicenseCheck";
const urlPrefix = "/plugins/org.graylog.plugins.securityapp.investigations/ai/config";
export const AI_CONFIGURATION_QUERY_STRING = "ai-configuration";
const getAIReportConfiguration = () => fetch("GET", qualifyUrl(urlPrefix)).then((response) => ({
  isEnabled: (response == null ? void 0 : response.ai_enabled) !== false
}));
const useAIConfiguration = () => {
  const {
    security: { isValid: validSecurityLicense },
    enterprise: { isValid: validEnterpriseLicense }
  } = useLicenseCheck();
  const hasValidLicense = validSecurityLicense || validEnterpriseLicense;
  const { data, isLoading } = useQuery({
    queryKey: [AI_CONFIGURATION_QUERY_STRING],
    queryFn: () => defaultOnError(
      getAIReportConfiguration(),
      "Fetching AI Configuration with status",
      "Could not fetch AI Configuration"
    ),
    enabled: hasValidLicense
  });
  return {
    data: data != null ? data : {
      isEnabled: false
    },
    isLoading
  };
};
export default useAIConfiguration;
